import { createReducer, on } from '@ngrx/store';
import { LocationStatisticsState } from './location-stat.models';
import * as statActions from './location-stat.actions';

export const initialState: LocationStatisticsState = {
  locationId: null,
  loading: false,
  error: null,
  data: null,
};

export const locationStatisticsReducer = createReducer(
  initialState,
  on(statActions.loadLocationStatistics, (state, { locationId }) => ({
    ...state,
    loading: true,
    locationId,
  })),
  on(
    statActions.loadLocationStatisticsSuccess,
    (state, { locationStatistics }) => ({
      ...state,
      loading: false,
      data: locationStatistics,
    })
  ),
  on(statActions.loadLocationStatisticsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  }))
);
